
import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;
if (base == undefined) {
    base = process.env.NODE_ENV == "production" ? window.apiAdress : 'http://localhost:9291';
}
//获取考核档案数据
export const getAssessmentFile = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetAssessmentFile`, { params: params }).then(res => res.data);
};

//获取迎评机构数据列表
export const getEvaluationAgencyList = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetEvaluationAgencyList`, { params: params }).then(res => res.data);
};

//修改当前档案的状态
export const GetUpdateStatus = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetUpdateStatus`, { params: params }).then(res => res.data);
};

//通过模块Id查询下面的考核细项
export const getDetailItemPassMoudleId = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetDetailItemPassMoudleId`, { params: params }).then(res => res.data);
};

//通过模块考核Id查询下面未自查的细项
export const postSelectNotCheck = params => {
    return axios.post(`${base}/api/AssessmentBusiness/PostSelectNotCheck`, params).then(res => res.data);
};

//通过细项Id查询对应的所有文件
export const getSelectDetaileFile = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetSelectDetaileFile`, { params: params }).then(res => res.data);
};

//删除文件
export const deleteFile = params => {
    return axios.get(`${base}/api/file/Del`, { params: params }).then(res => res.data);
};

//生成选中医疗机构基础考核业务信息
export const generateAssessment = (params, value) => {
    return axios.post(`${base}/api/Medicalorganization/GenerateAssessment?checkId=${value}`, params).then(res => res.data);
};
//查询评分机构列表
export const getSelectRatingAgencyList = (params, value) => {
    return axios.get(`${base}/api/AssessmentBusiness/GetSelectRatingAgencyList`, { params: params }).then(res => res.data);
};

//保存分数
export const postCalculateScore = (params, value) => {
    return axios.post(`${base}/api/AssessmentBusiness/PostCalculateScore`, params).then(res => res.data);
};

//审核考核档案
export const postExamine = (params, value) => {
    return axios.post(`${base}/api/AssessmentBusiness/PostExamine`, params).then(res => res.data);
};

//自查
export const getUpdateCheck = (params, value) => {
    return axios.get(`${base}/api/AssessmentBusiness/GetUpdateCheck`, { params: params }).then(res => res.data);
};

//下载文件
export const DownFiles = (params, value) => {

    return axios.post(`${base}/api/Img`, params, { responseType: "blob" }).then(res => res.data);
};

//查询考核细项 
export const getSelectDetailItem = (params, value) => {
    return axios.get(`${base}/api/AssessmentBusiness/GetSelectDetailItem`, { params: params }).then(res => res.data);
};

//整体上传
export const postUploadAllSave = (params, value) => {

    return axios.post(`${base}/api/AssessmentBusiness/PostUploadAllSave`, params, { headers: { "Content-Type": "multipart/form-data" } }).then(res => res.data);
};

//通过模块ID查询下面的细项扣分原因
export const postSelectDeductReason = (params, value) => {

    return axios.get(`${base}/api/AssessmentBusiness/PostSelectDeductReason`, { params: params }).then(res => res.data);
};

//首页查询当前登录人的未处理模块信息列表
export const getSelectNoModuleList = (params, value) => {

    return axios.get(`${base}/api/AssessmentBusiness/GetSelectNoModuleList`, { params: params }).then(res => res.data);
};

//修改模块状态
export const getUpdateModuleState = (params, value) => {

    return axios.get(`${base}/api/AssessmentBusiness/GetUpdateModuleState`, { params: params }).then(res => res.data);
};

//查看首页汇总数量 
export const getModuleStateCount = (params, value) => {

    return axios.get(`${base}/api/AssessmentBusiness/GetModuleStateCount`, { params: params }).then(res => res.data);
};
//修改考核负责人
export const editAssementFile = params => {
    return axios.get(`${base}/api/AssessmentBusiness/EditAssementFile`, { params: params }).then(res => res.data);
};
//修改考核档案状态
export const editAssementFileState = params => {
    return axios.get(`${base}/api/AssessmentBusiness/EditstateFile`, { params: params }).then(res => res.data);
};

//获取通过和未通过模块数量
export const GetModulePassInfo = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetModulePassInfo`, { params: params });
};

//下载模板文件
export const DownFiletemplate = params => {
    return axios.get(`${base}/api/RatingManage/DownFiletemplate?id=${params}`, { responseType: "blob" });
};

///查询扣分明细
export const asseDetailbadmessage = params => {
    return axios.post(`${base}/api/AssessmentBusiness/AssementDetailbadMessage`, params);
};
//查询所有的考核档案
export const getAssementFileList = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetAssementFileList`, { params: params });
};

///获取列表责任人下拉框
export const getzzrOptions = params => {
    return axios.get(`${base}/api/AssessmentBusiness/GetzzrOptions`, { params: params });
};



